import { DateRangeSelection } from '@shared/components'
import React from 'react'

import { FilterActions, useFiltersContext } from '@/context'

export const ReservationMoveOutFilter = () => {
  const [{ reservationMoveOutRange }, FilterDispatch] = useFiltersContext()
  const { moveOutDate, moveOutMax } = reservationMoveOutRange

  return (
    <DateRangeSelection
      className="mr-4"
      endDate={moveOutMax}
      headerTitle="Move Out Date"
      listFilter={true}
      setEndDate={(d?: Date) => {
        if (d) FilterDispatch(FilterActions.clearFilters({ filterName: 'reservations' }))
        FilterDispatch(FilterActions.setReservationMoveOutRange({ r: { moveOutMax: d } }))
      }}
      setStartDate={(d?: Date) => {
        if (d) FilterDispatch(FilterActions.clearFilters({ filterName: 'reservations' }))
        FilterDispatch(FilterActions.setReservationMoveOutRange({ r: { moveOutDate: d } }))
      }}
      startDate={moveOutDate}
    />
  )
}
